import swal from 'sweetalert2'

swal.setDefaults({
  buttonsStyling: false,
  confirmButtonClass: 'btn btn-danger btn-fill',
  cancelButtonClass: 'btn btn-default btn-fill',
})

let Dialogs = function (Vue, options = {}) {
  if (!options.i18n) {
    console.error(`Dialogs plugin requires options.i18n to be instance of vue-i18n `)
  }
  this.Vue = Vue
  this.options = options
}

Dialogs.prototype.confirm = function (title, text, confirmText) {
  return new Promise((resolve, reject) => {
    swal({
      title: title,
      html: text,
      cancelButtonClass: 'btn btn-default btn-outline-default btn-round btn-dialog-one-size ml-1',
      confirmButtonClass: 'btn btn-danger btn-outline-danger btn-round btn-dialog-one-size mr-1',
      cancelButtonText: this.options.i18n.t(`Cancel`),
      confirmButtonText: confirmText,
      showCancelButton: true,
      showConfirmButton: true
    }).then(result => {
      if (result) {
        resolve(true)
      } else {
        reject(false)
      }
    })
      .catch(swal.noop)
  })
}

Dialogs.prototype.info = function (title, text, confirmText) {
  return new Promise((resolve, reject) => {
    swal({
      title: title,
      html: text,
      cancelButtonClass: 'btn btn-default btn-outline-default btn-round btn-dialog-one-size',
      confirmButtonClass: 'btn btn-danger btn-outline-danger btn-round btn-dialog-one-size',
      cancelButtonText: this.options.i18n.t(`Cancel`),
      confirmButtonText: confirmText,
      showCancelButton: false,
      showConfirmButton: true
    })
  })
}

Dialogs.install = function (Vue, options) {
  if (!Vue.dialog) {
    Vue.dialog = new Dialogs(Vue, options)

    if (!Vue.prototype.hasOwnProperty('$dialog')) {
      Object.defineProperties(Vue.prototype, {
        $dialog: {
          get () {
            return Vue.dialog
          }
        }
      })
    }
  }
}

export default Dialogs